<span>{{ data | date : 'dd/MM/yyyy' }} <span class="sub-titulo"> às </span>{{ data | date : 'hh:mm' : '+00:00' }} </span>